// extracted by mini-css-extract-plugin
export var deleteModal = "_jj-0";